module.exports = __webpack_public_path__ + "img/life-sciences.bcfe4202.svg";